// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__YdPPb","colBig":"styles_colBig__2MQo0","colSmall":"styles_colSmall__2ueWa"};